import { CellContext, ColumnDef } from '@tanstack/react-table';
import React from 'react';
import FmtpTable from 'src/components/common/FmtpTable/FmtpTable';

import { formatEndpointAddressHtml } from 'src/util/formatters';
import { NewManifestGridProps, MappedManifest } from './types';
import { ShippingPortalLocation } from '@lanterds/types';

export default function NewManifestGrid({
    data,
    enableExpanding,
    enableRowSelection,
    setSelectedRows,
    selectedRows,
    onExpandedChange,
    expanded,
    isFetching = false,
}: NewManifestGridProps) {
    const getSubRows = (row: MappedManifest) => {
        return row.subRows as any;
    };

    const manifestColumns: ColumnDef<MappedManifest>[] = [
        {
            id: 'select',
            enableColumnFilter: false,
            header: 'Include in Manifest',
        },
        {
            accessorKey: 'tentativeManifestNumber',
            header: 'Manifest Number',
            meta: {
                isExpandable: true,
                innerHtml: ({ row }: CellContext<MappedManifest, unknown>) => {
                    const { manifestNumber, subRows } = row.original;

                    if (subRows) {
                        return manifestNumber;
                    } else {
                        return (
                            <div className={'body-cell-expandable subRow-expanded'}>
                                <div className="expanded">
                                    <span className="material-icons">subdirectory_arrow_right</span>
                                </div>
                            </div>
                        );
                    }
                },
            },
        },
        {
            accessorKey: 'parcelNumber',
            header: 'Barcode',
            enableSorting: false,
        },
        {
            accessorKey: 'reference',
            header: 'Reference',
            enableSorting: false,
        },
        {
            accessorKey: 'origin',
            header: 'Origin',
            meta: {
                innerHtml: ({ row }: CellContext<MappedManifest, unknown>) => {
                    const { origin, subRows } = row.original;
                    // Displaying location in manifest rows, and blank '-' values when parcel rows
                    if (subRows) {
                        return formatEndpointAddressHtml(origin as ShippingPortalLocation, true);
                    } else {
                        return origin as string;
                    }
                },
            },
        },
        {
            accessorKey: 'destination',
            header: 'Destination',
            meta: {
                innerHtml: ({ row }: CellContext<MappedManifest, unknown>) => {
                    const { destination, subRows } = row.original;
                    // Displaying location in manifest rows, and blank '-' values when parcel rows
                    if (subRows) {
                        return formatEndpointAddressHtml(destination as ShippingPortalLocation, true);
                    } else {
                        return destination as string;
                    }
                },
            },
        },
    ];

    return (
        <FmtpTable
            columns={manifestColumns}
            data={data}
            enableExpanding={enableExpanding}
            enableRowSelection={enableRowSelection}
            setSelectedRows={setSelectedRows}
            selectedRows={selectedRows}
            getSubRows={getSubRows}
            onExpandedChange={onExpandedChange}
            expanded={expanded}
            isFetching={isFetching}
        />
    );
}
